import { DetailsAllComponent } from './details-all/details-all.component';
import { AllHeaderComponent } from '../myinsurance-headers/all-header/all-header.component';
import { DetailsHomeComponent } from './details-home/details-home.component';
import { HomeHeaderComponent } from '../myinsurance-headers/home-header/home-header.component';
import { DetailsCarComponent } from './details-car/details-car.component';
import { DashboardNavComponent } from '../myinsurance-nav/dashboard-nav.component';
import { CarHeaderComponent } from '../myinsurance-headers/car-header/car-header.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { ChangeAddressService } from '../../../../../_services/change-address/change-address.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreAlertComponent, MapfreCardComponent, CarHeaderComponent, DashboardNavComponent, DetailsCarComponent, HomeHeaderComponent, DetailsHomeComponent, AllHeaderComponent, DetailsAllComponent],
  selector: 'app-policy-details-screen',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class PolicyDetailsComponent implements OnInit {
  loading = false;
  policyId: string;
  policyDetails: any;
  policy: any;
  showAlert = false;
  isAcmic = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private changeAddressService: ChangeAddressService,
    private alertService: AlertService,
    private navService: NavigationService,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policyDetails = policyResponse;
          this.loading = false;
        }
      });
    });
    this.showAlert = this.changeAddressService.getIsResidentialAddressUpdated();
    this.navService.saveCurrentAction(ActionType.AccessMyPolicy);
  }

  showMileageToastMessage(e) {
    this.showAlert = e;
  }

  showToastMessage(e) {
    this.showAlert = true;
    this.alertService.renewal(e);
    window.scroll(0, 0);
  }
}
